import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import Swal from "sweetalert2";

const List = () => {
  const location = useLocation();
  const [role, setRole] = useState(null);
  const [me, setMe] = useState(null);
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/damage`);
      const resMe = await Http.get(`/me`);
      const resRole = await Http.get(`/staff-type-check`);
      setReceiveData(res.data);
      setMe(resMe.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete(`/damage/${id}`)
          .then(() => {
            showAlert("Damage deleted successfully", "success");
            fetchData();
          })
          .catch(() => {
            showAlert("Failed to delete Damage", "error");
          });
      }
    });
  };

  // const handleReceive = (id) => {
  //   Swal.fire({
  //     title: "Confirm Receipt",
  //     text: "Mark this transfer as received?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonColor: "#28a745",
  //     cancelButtonColor: "#3085d6",
  //     confirmButtonText: "Yes, mark as received!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       Http.post(`/kitchen-transfer/${id}/receive`)
  //         .then(() => {
  //           showAlert("Transfer marked as received successfully", "success");
  //           fetchData();
  //         })
  //         .catch(() => {
  //           showAlert("Failed to mark transfer as received", "error");
  //         });
  //     }
  //   });
  // };

  const handleReceive = (id) => {
    Swal.fire({
      title: "Confirm Receipt",
      text: "Mark this damage as received?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, mark as received!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post(`/damage/${id}/receive`)
          .then(() => {
            showAlert("Damage marked as received successfully", "success");
            fetchData();
          })
          .catch(() => {
            showAlert("Failed to mark damage as received", "error");
          });
      }
    });
  };


  const cols = [
    { field: "damage_no", header: "Damage No" },
    { field: "date", header: "Damage Date" },
    { field: "time", header: "Damage Time" },
    { field: "status", header: "Damage Status" },
    { field: "notes", header: "Notes" },

    // {
    //   header: "Received By", field: (row) => (row.received_by ? 'Received By' + row.received_by.name :        
    //     (role && me && role === 'kitchen' && row.kitchen_id === me?.data?.id) ? <button className="btn btn-sm btn-primary" onClick={() => handleReceive(row.id)}> Receive Now</button> : 'waiting for kitchen receive'
    //   )
    // },
  ];

  const actionTemplate = (item) => {
    const isNotReceived = item.status !== 'received';

    return (
      <div className="btn-group" role="group">
        <Link
          to={`/show-damage/${item.id}`}
          className="btn btn-info btn-sm"
          title="Details"
        >
          <i className="fa fa-eye"></i>
        </Link> &nbsp;&nbsp;

        {isNotReceived && role === 'production' && (
          <button
            type="button"
            className="btn btn-success btn-sm"
            title="Receive"
            onClick={() => handleReceive(item.id)}
          >
            <i className="fa fa-check"></i>
          </button>
        )}
        {/* {isNotReceived && role === 'kitchen' && (
          <Link
          to={`/edit-damage/${item.id}`}
          className="btn btn-info btn-sm"
          title="Edit"
        >
          <i className="fa fa-pencil"></i>
        </Link>
        )} */}

        {isNotReceived && role === 'kitchen' && (
          <button
            type="button"
            className="btn btn-danger btn-sm  ms-1"
            title="Delete"
            onClick={() => deleteData(item.id)}
          >
            <i className="fa fa-trash"></i>
          </button>
        )}
      </div>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>

      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Return Lists</h5>
            {(role === "kitchen" || role === "kitchen_manager") && (
              <Link to="/create-damage" className="btn btn-primary">
                <i className="fa fa-plus-square mg-r-6"></i>New
              </Link>
            )}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              // deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
